/**
    顶部路由组件
    参数：
*/
<template>
  <div class="TRouteNav">
    <div class="wrapper">
      <div class="TPNleft">
        <div>
          <router-link to="/">
<!--            <el-image src="static/images/logo@BGRIMM.png" style="width:100px;height:100px;"></el-image>-->
<!--            <el-image src="static/images/logo@BGRIMM MTC-1.png" style="width:700px;height:63px;vertical-align:middle"/>-->
<!--            <el-image src="static/images/logo@BGRIMM MTC.png" style="width:100px;height:100px;"></el-image>-->
<!--            <el-image src="static/images/logo@BGRIMM MTC-2.png" style="width:700px;height:63px;vertical-align:middle"/>-->
<!--            <el-image src="static/images/logo@BGRIMM MTC-4.png" style="width:auto;height:70px;vertical-align:middle"/>-->
            <!--适配搜狗浏览器-->
<!--            <img src="static/images/logo@BGRIMM MTC-5.png"-->
<!--                 style="width:auto;height:70px;vertical-align:middle"-->
<!--                 @click="refresh"/>-->
            <img src="static/images/logo@BGRIMM MTC-2.png"
                 style="width:700px;height:63px;vertical-align:middle"
                 @click="refresh"/>
          </router-link>
        </div>
      </div>
      <div class="TPNright">
        <!-- 路由按钮 -->
        <div class="content"
             v-for="item in this.arr.type"
             :key="item.value"
             @click="routLinkTo(item.route)">
            <div class="personalText"
                 v-if="item.des != ''"
                 :class="{active_path : activeRoute === item.route }">
              {{ item.des }}
            </div>
        </div>
        <div class="searchItem">
          <input type="text" placeholder="快速检索" v-model="searchKeyWord" @keyup.enter="keyWordSearch">
          <button @click="keyWordSearch">
            <!-- 搜索 -->
            <svg t="1663573964767" class="icon" viewBox="0 0 1024 1024"
                 version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2378"
                 width="25" height="25">
              <path d="M469.333333 768c-166.4 0-298.666667-132.266667-298.666666-298.666667s132.266667-298.666667 298.666666-298.666666 298.666667 132.266667 298.666667 298.666666-132.266667 298.666667-298.666667 298.666667z m0-85.333333c119.466667 0 213.333333-93.866667 213.333334-213.333334s-93.866667-213.333333-213.333334-213.333333-213.333333 93.866667-213.333333 213.333333 93.866667 213.333333 213.333333 213.333334z m251.733334 0l119.466666 119.466666-59.733333 59.733334-119.466667-119.466667 59.733334-59.733333z"
                    p-id="2379"/>
            </svg>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TopTypeNav',
  props: {
    obj: Object
  },
  data () {
    return {
      arr: {
        'type': [
          {
            'value': 0,
            'des': '立即下单',
            'route': '/indexpage/productlist'
          },
          // {
          //   'value': 0,
          //   'des': '首页',
          //   'route': '/indexpage/index'
          // },
          // {
          //   'value': 1,
          //   'des': '立即下单',
          //   'route': '/indexpage/productlist'
          // },
          // {
          //   'value': 2,
          //   'des': '秒杀专区',
          //   'route': '/indexpage/seckill'
          // },
          // {
          //   'value': 3,
          //   'des': '拼团专区',
          //   'route': '/indexpage/combination'
          // },
          // {
          //   'value': 4,
          //   'des': '折扣专区',
          //   'route': '/indexpage/discount'
          // },
          // {
          //   'value': 5,
          //   'des': '领券中心',
          //   'route': '/indexpage/getcoupon'
          // }
          // {
          //   'value': 6,
          //   'des': '图文详情',
          //   'route': '/indexpage/noticedetail'
          // }
        ]
      },
      activeRoute: '/indexpage/index',
      searchKeyWord: ''
    }
  },
  watch: {
    $route (to, from) {
      this.activeRoute = to.path
    },
    obj: {
      handler (nVal, oVal) {
        var data = nVal.componentContent.typeRoute
        this.arr.type = data.map((item, index) => {
          return {
            'value': index,
            'des': item.des,
            'route': item.linkTo
          }
        })
      }
    }
  },
  methods: {
    refresh() {
      if(this.$route.path === '/indexpage/productlist') {
        location.reload();
      } else {
        this.routLinkTo('/');
      }
    },
    routLinkTo (val) {
      if (!val || val === this.$route.path) return;
      this.$router.push(val);
    },
    keyWordSearch () {
      this.$router.push({
        path: '/indexpage/productlist',
        query: {
          keyword: this.searchKeyWord
        }
      })
    }
  }
}
</script>

<style lang="scss">
.TRouteNav{
  height: 100px;
  line-height: 100px;
  background-color: #FFFFFF;
  .wrapper{
    max-width: 1440px;
    min-width: 1170px;
    margin: auto;
    div{
        display: inline-block;
    }
    .TPNleft{
        cursor: pointer;
        margin-left: 135px;
    }
    .TPNright{
      float: right;
      margin-right: 135px;
      cursor: pointer;
      color: #666666;
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 400;
      .content{
          margin-right: 20px;
          .personalText{
            height: 80px;
            padding: 0 10px;
            color: $mainColor;
          }
          .active_path{
            border-bottom: 2px solid $mainColor;
            font-weight: bold;
          }
      }
      .searchItem{
        margin: 0;
        padding: 0;
        input{
          width: 220px;
          height: 34px;
          padding-left: 20px;
          background-color: #F6F6F8;
          vertical-align: middle;
          border-radius: 3px;
        }
        button{
          font-size: 16px;
          color: #FFFFFF;
          width: 40px;
          height: 34px;
          /*background-color: #333333;*/
          /*background-color: $mainColor;*/
          background-color: #F6F6F8;
          cursor: pointer;
          border-radius: 3px;
          svg{
            vertical-align: middle;
            path{
              fill: $mainColor;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/TopTypeNav.vue